/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const SuccessionFilterTypeDto = {
    Zone: 'ZONE',
    Region: 'REGION',
    Department: 'DEPARTMENT',
    Position: 'POSITION',
    SuccessionPosition: 'SUCCESSION_POSITION',
    SuccessionDepartment: 'SUCCESSION_DEPARTMENT',
    Grade: 'GRADE',
    EmployeeSuccessionReadiness: 'EMPLOYEE_SUCCESSION_READINESS',
    Matrix: 'MATRIX',
    JobLevel: 'JOB_LEVEL',
    Mt: 'MT',
    FunctionalArea: 'FUNCTIONAL_AREA',
    HierarchicalSupervisor: 'HIERARCHICAL_SUPERVISOR',
    FunctionalSupervisor: 'FUNCTIONAL_SUPERVISOR',
    SopRating: 'SOP_RATING',
    PmcRating: 'PMC_RATING',
    Mobility: 'MOBILITY',
    AgeBucket: 'AGE_BUCKET'
} as const;

export type SuccessionFilterTypeDto = typeof SuccessionFilterTypeDto[keyof typeof SuccessionFilterTypeDto];



